<div
  class="backdrop"
  [@display]="isOpened"
  [@opacity]="isOpened"
  (click)="close()"
></div>

<div class="sidenav" [@popOver]="isOpened">
  <div class="menu-sidenav">
    <div
      class="sidenav-option"
      [routerLink]="tab.link"
      routerLinkActive="active"
      *ngFor="let tab of tabs"
      (click)="changeTab(tab); close()"
      [ngClass]="{ active: tab.currentTab }"
    >
      <md-icon class="icon">{{ tab.icon }}</md-icon> {{ tab.title }}
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/sidenav/sidenav.component.html